<div class="dialog-container">
  <div class="dialog-header flex justify-between items-center mb-[16px]">
    <div class="dialog-title">Materials for {{ bidItem?.item }}</div>
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  @if (!materials.length) {
    <div class="no-materials text-type-11 text-[#8b94b3] my-[16px]">
      No materials in this project. Add materials in the Materials tab first.
    </div>
  }

  <div class="materials-list">
    @for (material of materials; track material) {
      <div class="material-row">
        <mat-checkbox
          color="primary"
          [checked]="material.checked"
          (change)="onChange(material, $event.checked)"
          >
          <span class="text-type-11">{{ material.name }}</span>
          <span class="text-type-14 text-[#8B94B3] ml-[4px]">({{ material.uom }})</span>
        </mat-checkbox>
      </div>
    }
  </div>
</div>
